/**
 * @generated SignedSource<<929230ceb9941390a54f78d0fcd40f06>>
 * @relayHash 62034951ad478b9310149b860e0e5d76
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dc489ea573805d3058b4220a278b462df520be5380ad0c5861fb89ed6d98d79d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type issueTypeQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
};
export type issueTypeQuery$data = {
  readonly node: {
    readonly issueTypesForTransition?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly small: string | null | undefined;
          } | null | undefined;
          readonly label: string;
          readonly value: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type issueTypeQuery = {
  response: issueTypeQuery$data;
  variables: issueTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "filterById",
    "variableName": "filterById"
  }
],
v3 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "issueTypeQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypesForTransition",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraIssueTypeField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "issueTypeQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypesForTransition",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraIssueTypeField"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "dc489ea573805d3058b4220a278b462df520be5380ad0c5861fb89ed6d98d79d",
    "metadata": {},
    "name": "issueTypeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fffc08bf530de123da55bbae6d5a77bb";

export default node;
